module.exports = __webpack_public_path__ + "static/media/Julia_Gillard_2010.8471e99b.jpg";